import type {CaseReducer, PayloadAction} from '@reduxjs/toolkit'

import type {ConfirmationDecision} from '../../services/pipelinesApi.types'

import type {PipelineDraftState} from './EditPipelinePage.slices.types'
import {getPipelineDraftEntry} from './EditPipelinePage.slices.utils'

export const setVersionedSettings: CaseReducer<
  PipelineDraftState,
  PayloadAction<{
    id: string
    storedInRepo?: boolean
    filename?: string | null
    confirmationDecision?: ConfirmationDecision
    branch: string
  }>
> = (state, action) => {
  const {id, filename = null, branch, ...updatedSettings} = action.payload
  const {draft} = getPipelineDraftEntry(state, id, branch) ?? {}

  if (draft != null) {
    draft.versionedSettings = {
      ...draft.versionedSettings,
      filename,
      ...updatedSettings,
    }
  }
}
